<template>

    <LinkHover type="button" :class="['cross']" @click.native="click">
        <span
            class="default cross-holder"
        >
        </span>
        <template v-slot:hover>
            <span
                class="hover cross-holder"
            >
            </span>
        </template>
    </LinkHover>
</template>
<script>
import LinkHover from '@/components/animation/LinkHover'
export default {
    components: {
        LinkHover
    },
    props: {
        size: {
            type: Number,
            default: 77
        }
    },
    methods: {
        click() {
            this.$emit('click')
        }
    }
}
</script>
<style lang="sass" scoped>
@import "@/styles/vars.sass"
.cross
    position: relative
    cursor: pointer
    height: 77px !important
    width: 77px

    @include media-breakpoint-down($sm)
        height: 50px !important
        width: 50px
    .cross-holder
        position: relative
        width: 100%
        display: block
        background: #ff2b2a
        &:before, &:after
            content: ""
            position: absolute
            display: block
            top: 50%
            left: 50%
            width: 24px
            height: 2px
            background: #ffffff
            transform: translateX(-50%) translateY(-50%) rotate(45deg)
        &.hover
            background-color: #002561
            // &:before, &:after
            //     background: #ff2b2a

        &:after
            transform: translateX(-50%) translateY(-50%) rotate(-45deg)
</style>
